import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["colorSet"];
import React from 'react';
import { spacer12 } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { IconCheckAlt } from "../Icon/IconCheckAlt";
import { IconExclamationAlt } from "../Icon/IconExclamationAlt";
import { IconInformationAlt } from "../Icon/IconInformationAlt";

var getIconByColorSet = function getIconByColorSet(colorSet) {
  switch (colorSet) {
    case 'negative':
      {
        return IconExclamationAlt;
      }

    case 'warning':
      {
        return IconExclamationAlt;
      }

    case 'positive':
      {
        return IconCheckAlt;
      }

    default:
      {
        return IconInformationAlt;
      }
  }
};

var BannerIcon = function BannerIcon(_ref) {
  var colorSet = _ref.colorSet,
      props = _objectWithoutProperties(_ref, _excluded);

  var Component = getIconByColorSet(colorSet);
  return Component ? /*#__PURE__*/React.createElement(Component, Object.assign({
    "aria-hidden": "true"
  }, props), undefined) : null;
};

export var Icon = styled(BannerIcon).attrs({
  suppressClassNameWarning: true
}).withConfig({
  displayName: "Icon",
  componentId: "sc-1mveit9-0"
})(["margin-inline-end:", ";"], spacer12);